import axios from 'axios'
import { DESEMBARCAR_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function desembarcarEncomenda (idEmpresa, idEncomenda) {
  const url = `${URL}/encomendas/empresa/${idEmpresa}/encomenda/${idEncomenda}/desembarcar-encomenda`;
  return dispatch => axios.post(url,null , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: DESEMBARCAR_ENCOMENDA,
        payload: response
      })
  );
}